import isFunction from 'lodash/isFunction';
import {
  PRE_MUTATE_CARD_NUMBER_REGXP,
  PRE_MUTATE_ZIP_CODE_REGXP,
  CANADA_ZIP_CODE_FORBIDDEN_CHARACTERS,
  PRE_MUTATE_PHONE_REGXP,
} from '../../../constants/patterns';

const fieldToPatternMap = {
  cardNumber: PRE_MUTATE_CARD_NUMBER_REGXP,
  zipCode: (value, formData) => {
    switch (formData.countryAbbreviation) {
      case 'US':
        return PRE_MUTATE_ZIP_CODE_REGXP.test(value);

      case 'CA':
        return !CANADA_ZIP_CODE_FORBIDDEN_CHARACTERS.test(value);

      default:
        return false;
    }
  },
  phone: PRE_MUTATE_PHONE_REGXP,
};

export default function refundCardFormPremutations(formData, key, value) {
  const pattern = fieldToPatternMap[key];

  if (!pattern) {
    return true;
  }

  if (isFunction(pattern)) {
    return pattern(value, formData);
  }

  return pattern.test(value);
}
